export default {"src":"/_next/static/media/favicon.1f997ebf.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};